import { createReducer } from '@reduxjs/toolkit';
import { fetchQuestionSet, getAnalyticsToken, fetchPracticeList, fetchCohortsQuestionSet, fetchCohorts, resetQuestionSets } from 'redux/actions/analytics';
import { AnalyticsDashBoardType, QrveyState } from 'redux/schemas/app/analytics';
import { initialRootState } from '.';


export const initialQrveyState: QrveyState = {
  isLoading: false,
  type: AnalyticsDashBoardType.UNSET,
};

export default createReducer(initialRootState, builder => {
  builder
    .addCase(getAnalyticsToken.pending, (state, action) => {
      state.app.qrveyConfig.isLoading = true;
    })
    .addCase(getAnalyticsToken.fulfilled, (state, action) => {
      state.app.qrveyConfig = { ...action.payload, type: action.meta.arg.type, isLoading: false };
    })
    .addCase(fetchQuestionSet.fulfilled, (state, action) => {
      state.app.analytics.questionSets = action.payload;
      state.app.analytics.questionSetsLoaded = true;
    })
    .addCase(fetchCohortsQuestionSet.fulfilled, (state, action) => {
      state.app.analytics.questionSets = action.payload;
      state.app.analytics.questionSetsLoaded = true;
    })
    .addCase(fetchPracticeList.fulfilled, (state, action) => {
      state.app.analytics.practiceList = action.payload;
      state.app.analytics.isPracticeListLoaded = true;
    })
    .addCase(fetchPracticeList.pending, (state, action) => {
      state.app.analytics.isPracticeListLoaded = false;
    })
    .addCase(fetchCohorts.pending, (state) => {
      state.app.analytics.isCohortsListLoaded = false;
    })
    .addCase(fetchCohorts.fulfilled, (state, action) => {
      state.app.analytics.cohorts = action.payload;
      state.app.analytics.isCohortsListLoaded = true;
    })
    .addCase(resetQuestionSets, (state) => {
      state.app.analytics.questionSets = {};
      state.app.analytics.questionSetsLoaded = false;
    });
});
